import React from "react";
import { Link } from "react-router-dom";

const Security = () => {
  return (
    <div className="space-y-4">
      {/* Change Password Link */}
      <div className="mt-8 text-center">
        <Link
          to="/auth/forgot-password"
          className="text-blue-600 hover:underline text-sm dark:text-blue-400"
        >
          Want to change your password?
        </Link>
      </div>
    </div>
  );
};

export default Security;
